import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable, take } from 'rxjs';

import { CustomError } from '@efficiently/client-core-classes';
import type { GenerateMcpApiKeyMutation } from '@efficiently/client-core-graphql-models';

import { AuthClient } from '@ds/core/enums/auth-client.enum';

import { GENERATE_MCP_API_KEY, GET_MCP_API_KEY_PREFIX } from './queries';

export type McpApiKeyResponse = NonNullable<GenerateMcpApiKeyMutation['generateMcpApiKey']>;

@Injectable({
	providedIn: 'root',
})
export class McpGqlService {
	private readonly apollo = inject(Apollo);

	public generateMcpApiKey(): Observable<McpApiKeyResponse> {
		return this.apollo
			.mutate({
				mutation: GENERATE_MCP_API_KEY,
				context: {
					client: AuthClient.Identity,
				},
			})
			.pipe(
				map(({ data }) => {
					const key = data?.generateMcpApiKey;

					if (!key) {
						throw new CustomError('MCP API key generation returned no key');
					}

					return key;
				}),
				take(1),
			);
	}

	public getMcpApiKeyPrefix(): Observable<string | null> {
		return this.apollo
			.query({
				query: GET_MCP_API_KEY_PREFIX,
				context: {
					client: AuthClient.Identity,
				},
				fetchPolicy: 'network-only',
			})
			.pipe(
				map(({ data }) => data?.mcpApiKeyPrefix ?? null),
				take(1),
			);
	}
}
